exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".Form--cms .FormInputRequired{border-left:6px solid #20203e}.Form--cms .FormLabelRequired{color:#404070}.Form--cms .form-inner{background:#efefef;padding:1em;margin-bottom:2em;border:1px solid #e1e1e1;box-shadow:0 0 8px -2px rgba(0,0,0,.2)}.Form--cms .form-single{padding-top:50px;padding-bottom:50px;max-width:420px;margin:auto}.Form--cms .Form-Field{padding-bottom:15px}.Form--cms .FormInputRequired{border-left:6px solid #3e2020}.Form--cms .FormLabelRequired{color:#94040f}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./~/postcss-loader!./src/theme/pages/form/Form.scss
// module id = 751
// module chunks = 0